export default {
    data() {
        return {

        }
    },
    methods: {
        download(url) {
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", ""); //or any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/downloadMixin.js